import { Box, Button, Grid } from '@chakra-ui/react';
import React, { useEffect, useMemo, useState } from 'react';
import { CartridgeInfoType, SetCartridgeType } from './Pages/SetCartridgeType/setCartridgeType';
import { SetPrice } from './Pages/SetPrice/setPrice';
import { StepNavigation } from './StepNavigation/stepNavigation';
import { Formik, useFormikContext } from 'formik';
import { FORM_CONFIG } from './formConfig';
import { t } from 'i18next';
import { getValidationSchema } from './schema';
import { ContentContainer } from '../ContentContainer/contentContainer';
import { ProgressBar } from '../ProgressBar/progressBar';
import { SetNameAndSymbol } from './Pages/SetNameAndSymbol/setNameAndSymbol';
import { SetCoverImage } from './Pages/SetCoverImage/setCoverImage';
import { SetIconImage } from './Pages/SetIconImage/setIconImage';
import { SetSocials } from './Pages/SetSocials/setSocials';
import { Finalization } from './Pages/Finalization/finalization';
import { SetDescription } from './Pages/SetDescription/setDescription';
import { SetColors } from './Pages/SetColors/setColors';
import { SetTags } from './Pages/SetTags/setTags';
import { SetPlatforms } from './Pages/SetPlatforms/setPlatforms';
import { cartridges } from './Pages/SetCartridgeType/cartridges';
import { SetScreenshotsAndVideo } from './Pages/SetScreenshotsAndVideo/setScreenshotsAndVideo';
import { SetPromo } from './Pages/SetPromo/setPromo';
import { SetSupply } from './Pages/SetSupply/setSupply';
// import { useLocalStorage } from 'usehooks-ts';
import { LoadSteamData } from './LoadSteamData/loadSteamData';
import { useCartridgeCreatorProvider } from 'src/providers/Cartridge/cartridgeProvider';
import { Color } from 'src/theme/color';
import { SetMarketplaceFee } from './Pages/SetMarketplaceFee/setMarketplaceFee';
import { useLocalStorage } from 'src/lib/Hooks';

export const CartridgeForm = () => {
	const [currentStep, setCurrentStep] = useState<number>(FORM_CONFIG.FIRST_FORM_PAGE);
	const [selectedCartridge, setSelectedCartridge] = useState<CartridgeInfoType>(
		cartridges[FORM_CONFIG.DEFAULT_CARTRIDGE_NUMBER]
	);

	const { restartUpload } = useCartridgeCreatorProvider();

	const currentSchema = useMemo(
		() => getValidationSchema(currentStep, selectedCartridge, 100000, t),
		[currentStep, selectedCartridge, t]
	);

	const [formData, setFormData] = useLocalStorage('hashupForm', 'init') as [any, any];

	return (
		<Formik
			initialValues={FORM_CONFIG.INITIAL_VALUES}
			onSubmit={() => {}}
			validationSchema={currentSchema}
		>
			{props => {
				const validate = async () => {
					let success = false;
					await currentSchema.validate(props.values).then(
						() => (success = true),
						err => {}
					);

					setFormData(JSON.stringify({ values: props.values, step: currentStep }));

					return success;
				};

				const loadPrevious = () => {
					props.setValues((JSON.parse(formData) as any).values);
					setCurrentStep((JSON.parse(formData) as any).step);
					restartUpload();
				};

				const deletePrevious = () => {
					restartUpload();
				};

				const pageOptions: any = {
					1: () => (
						<SetCartridgeType
							nextStep={() => setCurrentStep(currentStep + 1)}
							setSelectedCartridge={setSelectedCartridge}
							loadPrevious={loadPrevious}
							deletePrevious={deletePrevious}
							backupAvailable={formData != ''}
						/>
					),
					2: () => <SetTags />,
					3: () => <SetPlatforms />,
					4: () => <SetCoverImage selectedCartridge={selectedCartridge} />,
					5: () => <SetNameAndSymbol />,
					6: () => <SetSocials />,
					7: () => <SetIconImage />,
					8: () => <SetColors />,
					9: () => <SetScreenshotsAndVideo />,
					10: () => <SetPromo />,
					11: () => <SetDescription />,
					12: () => <SetPrice />,
					13: () => <SetMarketplaceFee />,
					14: () => <SetSupply />,
					15: () => <Finalization />,
				};

				return (
					<Grid>
						{currentStep > 1 && (
							<ProgressBar
								currentStep={currentStep}
								maxSteps={FORM_CONFIG.FORM_PAGES_COUNT}
							/>
						)}
						<Box bg={Color.FORM_BACKGROUND}>
							{currentStep > 3 ? (
								<Box color="white">{pageOptions[currentStep]()}</Box>
							) : (
								<ContentContainer>{pageOptions[currentStep]()}</ContentContainer>
							)}
						</Box>
						{currentStep > 1 && (
							<StepNavigation
								setCurrentStep={setCurrentStep}
								currentStep={currentStep}
								isValid={validate}
								currentCartridge={selectedCartridge}
								currentSchema={currentSchema}
							/>
						)}
					</Grid>
				);
			}}
		</Formik>
	);
};
